import { render, staticRenderFns } from "./SubCategoryRow.vue?vue&type=template&id=32c816c3&scoped=true"
import script from "./SubCategoryRow.vue?vue&type=script&lang=js"
export * from "./SubCategoryRow.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryRow.vue?vue&type=style&index=0&id=32c816c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c816c3",
  null
  
)

export default component.exports